import { filterDiffFunction } from './chunk-WTGT4IDV.mjs';
import { selectMenu, selectOriginalMenuData, selectChangeDataId, selectCurrentItem } from './chunk-67X7HZEW.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import difference from 'lodash/difference';

var IngredientBasicSectionFieldLabels = /* @__PURE__ */ ((IngredientBasicSectionFieldLabels2) => {
  IngredientBasicSectionFieldLabels2[IngredientBasicSectionFieldLabels2["active"] = 0] = "active";
  IngredientBasicSectionFieldLabels2[IngredientBasicSectionFieldLabels2["name"] = 1] = "name";
  IngredientBasicSectionFieldLabels2[IngredientBasicSectionFieldLabels2["posName"] = 2] = "posName";
  return IngredientBasicSectionFieldLabels2;
})(IngredientBasicSectionFieldLabels || {});
var IngredientAssociationSectionFieldLabels = /* @__PURE__ */ ((IngredientAssociationSectionFieldLabels2) => {
  IngredientAssociationSectionFieldLabels2[IngredientAssociationSectionFieldLabels2["itemIds"] = 0] = "itemIds";
  return IngredientAssociationSectionFieldLabels2;
})(IngredientAssociationSectionFieldLabels || {});
var IngredientInventorySectionFieldLabels = /* @__PURE__ */ ((IngredientInventorySectionFieldLabels2) => {
  IngredientInventorySectionFieldLabels2[IngredientInventorySectionFieldLabels2["is86ed"] = 0] = "is86ed";
  return IngredientInventorySectionFieldLabels2;
})(IngredientInventorySectionFieldLabels || {});
var returnLabel = (field) => {
  if (field in IngredientBasicSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.itemsDiff.basic.${field}`
    );
  }
  if (field in IngredientAssociationSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.menuTypesDiffModal.master.${field}`
    );
  }
  if (field in IngredientInventorySectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.itemsDiff.inventory.${field}`
    );
  }
};
var getItemsChanges = (hasSomeItemIds, bucketItemIds, itemIds, items, templateIds) => {
  const itemsValues = [];
  if (hasSomeItemIds) {
    const removedItemIds = difference(bucketItemIds, itemIds);
    const addedItemIds = difference(itemIds, bucketItemIds);
    if (removedItemIds.length > 0) {
      removedItemIds.map((removedItemId) => {
        const itemName = items ? items[removedItemId].name : "";
        itemsValues.push({
          action: "remove",
          id: removedItemId,
          menuTypeIds: [],
          value: itemName
        });
      });
    }
    if (addedItemIds.length > 0) {
      addedItemIds.map((addedItemId) => {
        const itemName = items ? items[addedItemId].name : "";
        itemsValues.push({
          action: "add",
          id: addedItemId,
          value: itemName,
          menuTypeIds: templateIds[addedItemId]
        });
      });
    }
  }
  return itemsValues;
};
var diffIngredientsFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const currentMenu = selectMenu(state);
    const originalData = selectOriginalMenuData(state);
    const items = currentMenu.items;
    const ingredientId = selectChangeDataId(state);
    const ingredientItemIds = originalData.itemIds;
    const changeData = selectCurrentItem(state);
    const currentItemIds = changeData.itemIds;
    const itemMenuTypeIds = changeData.itemMenuTypeIds;
    const hasSomeItemIds = diffArray.filter(
      (diff) => diff.path[0] === "itemIds"
    ).length;
    const itemValues = getItemsChanges(
      Boolean(hasSomeItemIds),
      ingredientItemIds,
      currentItemIds,
      items,
      itemMenuTypeIds
    );
    const itemsChanges = {
      field: "itemIds",
      label: returnLabel("itemIds"),
      value: itemValues
    };
    const associationsItems = [];
    if (itemValues.length > 0) {
      associationsItems.push(itemsChanges);
    }
    const diffObject = {
      ingredientId,
      basic: generateBasicArray(diffArray),
      inventory: generateInventoryArray(diffArray),
      associations: {
        items: associationsItems
      }
    };
    return diffObject;
  }
  return null;
};
var generateBasicArray = (diffArray) => {
  const basic = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (field in IngredientBasicSectionFieldLabels) {
          basic.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return basic;
};
var generateInventoryArray = (diffArray) => {
  const inventory = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (field in IngredientInventorySectionFieldLabels) {
          inventory.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return inventory;
};

export { IngredientAssociationSectionFieldLabels, IngredientBasicSectionFieldLabels, IngredientInventorySectionFieldLabels, diffIngredientsFactory, getItemsChanges };
